import { render, staticRenderFns } from "./ProfileProgressBar.vue?vue&type=template&id=d44b5276"
import script from "./ProfileProgressBar.vue?vue&type=script&lang=js"
export * from "./ProfileProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports